import Cookies from '@mentimeter/cookies';
import { LocalStorage } from '@mentimeter/storage';

const USER_LOCALE_STORAGE_KEY = 'mm-user-locale';

/**
 * @deprecated use `getLocaleFromCookieOnClient`/`getLocaleFromCookieOnServer` from '@mentimeter/i18n-core' wherever possible.
 */
export const getUserLocale = () => {
  const cookieLocale = Cookies.get(USER_LOCALE_STORAGE_KEY);

  if (cookieLocale) return cookieLocale;

  return LocalStorage.getItem(USER_LOCALE_STORAGE_KEY) || undefined;
};
